import { useState } from 'react';

import { getCookie, setCookie } from '@/utils/cookies';

const ONE_YEAR_IN_MS = 365 * 24 * 60 * 60 * 1000;

export const useDismissableNotification = (cookieKey: string) => {
  const [isHidden, setIsHidden] = useState(() => getCookie(cookieKey));

  const dismiss = () => {
    setCookie(cookieKey, 'true', {
      cookieOptions: {
        expires: new Date(Date.now() + ONE_YEAR_IN_MS),
      },
    });
    setIsHidden('true');
  };

  return { isHidden, dismiss };
};
